import { format, parse } from 'date-fns';

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_START_HOUR = '08:00';
export const DEFAULT_END_HOUR = '18:00';

export const DATE_FORMAT = 'dd/LL/yyyy';

export const hourRules = {
  pattern: {
    value: /^[0-2][0-9]:[0-5][0-9]$/,
    message: 'Hora inválida!'
  }
};

export const dateRules = {
  required: 'Data é obrigatória',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};

export const convertToBrazilianDateFormat = (dateString) => {
  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  return format(date, 'dd/MM/yyyy');
};

export const convertToInternationalDateFormat = (dateString) => {
  const date = parse(dateString, 'dd/MM/yyyy', new Date());
  return format(date, 'yyyy-MM-dd');
};

export const convertToShortTimeFormat = (timeString) => {
  return timeString.substring(0, 5);
};

export const convertToLongTimeFormat = (timeString) => {
  return `${timeString}:00`;
};
